import React from "react";
import { Typography } from "@mui/material";
import { FunctionComponent } from "react";

interface NameplateProps {
  name: string;
  role?: string;
}

const Nameplate: FunctionComponent<NameplateProps> = ({ name, role }) => {
  return <Typography>{`${name} ${role ? `[${role}]` : ""}`}</Typography>;
};

export default Nameplate;
